import { Box, Dialog, DialogContent, Grid2, styled, Typography } from "@mui/material";
import CloseButton from "../../../Components/CloseButton";
import { PrimaryFormLoadingActionButton } from "../../../Features/Table/GenericDraggableTable/TableStyles";
import { useBaseEntityLabel } from "../../../Hooks/usePagesContent";

const StyledDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiPaper-root": {
        borderRadius: '12px',
        boxShadow: '-2.25px -2.25px 4.51px 0px rgba(151, 151, 151, 0.08)',
        width: "490px",
        maxWidth: "100%",
        backgroundColor: '#FFFFFF',
    },
}));


const ChangeDeviceAlertDialog = ({open, onClose, onConfirm}) => {
    // globalConfig.baseEntity.label (e.g. "Truck"); "Vehicle" when the org has not set one.
    const entityLabel = useBaseEntityLabel("Vehicle");
    const entityWord = entityLabel.toLowerCase();
    return (
        <StyledDialog open={open} onClose={onClose}>
            <DialogContent sx={{py: 3}}>
            <Grid2 sx={{ mb: 1.5 }}>
                <Box sx={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center', mb: -0.5}}>
                    <CloseButton onClick={onClose} />
                </Box>
                <Grid2 container flexDirection={'column'} alignItems={'center'} gap={3} flexWrap={'nowrap'}>
                    <Typography variant="fw600s16c000000" sx={{ fontSize: '18px' }}>Attention! Changing {entityLabel}</Typography>
                    <Typography variant="fw400s16c000000" sx={{textAlign: 'center'}}>Changing the {entityWord} will refresh this page. You will lose the existing charts created and have to start over if you proceed to choose a different {entityWord}</Typography>
                    <Grid2 container gap={1} justifyContent={'center'} alignItems={'center'} marginTop={1.5}>
                        <PrimaryFormLoadingActionButton
                                onClick={onClose}
                                sx={{
                                    border: '1px solid #EBEFF3',
                                    backgroundColor: 'transparent',
                                    color: '#3D4B5A',
                                    '&:hover': {
                                        backgroundColor: 'rgba(77, 68, 216, 0.04)',
                                        color: '#3D4B5A',
                                    }
                                }}
                            >
                                Cancel
                            </PrimaryFormLoadingActionButton>
                            <PrimaryFormLoadingActionButton
                                onClick={onConfirm}
                                sx={{
                                    backgroundColor: '#6D72F6',
                                    color: '#FFFFFF',
                                    '&:hover': {
                                        backgroundColor: '#4D44D8',
                                        color: '#FFFFFF !important',
                                    }
                                }}
                            >
                                Proceed
                            </PrimaryFormLoadingActionButton>
                        </Grid2>
                    </Grid2>
                </Grid2>
            </DialogContent>
        </StyledDialog>
    )
}

export default ChangeDeviceAlertDialog;
